class StockistsLink extends HTMLElement {
  constructor() {
    super();

    this.originalLink = this.querySelector('a');
    this.containerId = this.originalLink.href.split("#").pop();
    this.categoryKey = this.containerId.split("-").pop();
    this.container = document.getElementById(this.containerId);

    this.addEventListener('click', this.onClick);
    
    setTimeout(() => {
      this.showIfNeeded();
    });

    window.addEventListener("popstate", (ev) => {
      this.showIfNeeded();
    });
  }

  onClick(ev) {
    ev.preventDefault();

    this.show();
  }

  hide() {
    this.originalLink.classList.remove("active");
    this.container.classList.remove("active");
  }

  show(push = true) {
    if (this.originalLink.classList.contains('active')) return

    this.siblings().forEach((link) => {
      link.hide();
    });
    this.originalLink.classList.add("active");
    this.container.classList.add("active");

    if (push) {
      window.history.pushState(
        {},
        "",
        `#${this.categoryKey}`
      );
    }
  }

  showIfNeeded() {
    let hash = location.href.split("#").pop();
    if (hash == this.categoryKey) {
      this.show(false);
    }
  }

  siblings() {
    return Array.from(
      this.parentElement.querySelectorAll(this.tagName.toLowerCase())
    )
    .filter(link => link != this);
  }
}

customElements.define('stockists-link', StockistsLink);